import { render, staticRenderFns } from "./Veterinary.vue?vue&type=template&id=6e6501ab"
import script from "./Veterinary.vue?vue&type=script&lang=ts"
export * from "./Veterinary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports